export default (_error: Error): null => null
